/* eslint-disable linebreak-style */
/* eslint-disable react/prop-types */
/* eslint-disable linebreak-style */
import React from 'react';
import Popup from 'reactjs-popup'
import { connect } from 'react-redux';
import { dynamicSort,dynamicMultipleSort } from '../../../../utils/functiiComune';
import { selectOrderCurrentProduct, selectOrderCurrentOrder, selectOrderCurrentItem, selectOrderUpdatedOrder } from '../../../../redux/order/order.selectors'
import { selectLookupProduse,selectLookupOptionale, selectLookupMateriale } from '../../../../redux/lookup/lookup.selectors'
import { selectOtherLoading, selectOtherOpenEditItem, selectOtherErrors } from '../../../../redux/other/other.selectors'
import { selectCurrentUser } from '../../../../redux/user/user.selectors'
import { setLoading, setOpenEditItem, setErrors, resetErrors, setErrorsAsync } from '../../../../redux/other/other.actions'
import { setCurrentItem } from '../../../../redux/order/order.actions'
import { mpJV, actJV, pretJV, carucioareJV } from './functii';
import './reperedit.css';
import debounce from 'lodash.debounce'
import { validation } from './validation'
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  Button,
  TextField,
  InputAdornment,
  colors,
  Hidden
} from '@material-ui/core'; 
import { withSnackbar } from 'notistack';
import { t } from '../../../../i18n';
import { getLookupLabel, getLookupWarning } from '../../../../utils/lookupLocale';


class ReperEdit extends React.Component {
  constructor(props) {
    super(props);
    this.produse=props.produse?props.produse.filter(produs=>produs.tipProdus==='JV' && [3,4,10,11].includes(produs.key)):[];
    console.log('produse', this.produse)
    this.fieldsMaterial = { text: 'denumire', value: 'key' };
    this.fieldsDeschidere = { text: 'denumire', value: 'value' };
    this.optionale=props.optionale?props.optionale.filter(optional=>optional.tipProdus==='JV').sort(dynamicMultipleSort('pozitieLista','denumire')):[];
    this.deschideri = [
      { denumire: '1', key: '1', atentionare: t('orderLineForm.openingHint1') },
      { denumire: '2', key: '2', atentionare: t('orderLineForm.openingHint2') },
      { denumire: '3', key: '3', atentionare: t('orderLineForm.openingHint3') },
      { denumire: '4', key: '4', atentionare: t('orderLineForm.openingHint4') },
      { denumire: 'L', key: 'L', atentionare: t('orderLineForm.openingHintL') },
      { denumire: 'DA', key: 'DA', atentionare: t('orderLineForm.openingHintDA') }]
  }

  //-------------------------------------------------------------------------------------------------------------------
  
  onChangeTipSubprodus= (e)=>{ 
    e.persist() 
    const {setCurrentItem, currentItem}=this.props;
    let key = 'tipSubprodus';
    let key2='denumireSubProdus'
    let value=null;
    let value2='';
    if (currentItem){
      value = e.target.value?this.produse.filter(produs=>produs.denumire===e.target.value)[0].key:0
      value2=e.target.value?e.target.value:''
    }
    setCurrentItem({...currentItem, [key]: value, [key2]:value2, material:0, denumireMaterial:'',culoareLamela:0, denumireCuloareLamela:'', culoareCaseta: null, denumireCuloareCaseta: ''})
    debounce(this.calculPretCatalog,500)()
    debounce(this.calculMp,500)()
  
    setTimeout(() => {
      validation(this.props.currentItem,this.props.errors,this.props.setErrors);
      this.handleAtentionareTipSubprodus(e);
    }, 501);
  }

  //-------------------------------------------------------------------------------------------------------------------
  
  
  onChangeMaterial = (e) => {
    e.persist()
    const { setCurrentItem, currentItem, materiale } = this.props;
    let key = 'material';
    let key2 = 'denumireMaterial'
    let value = null;
    let value2 = '';
    if (currentItem) {
      // value = e.target.value ? materiale.filter(mat => mat.denumire === e.target.value && mat.tipProdus.toUpperCase() === 'JV')[0]?.key : 0
      value = e.target.value?this.produse.filter(produs=>produs.denumire===currentItem.denumireSubProdus)[0].materialeCompatibile.filter(material=>material.denumire===e.target.value)[0].key:0
      value2 = e.target.value ? e.target.value : ''
    }
    setCurrentItem({ 
      ...currentItem, 
      [key]: value, 
      [key2]: value2, 
      culoareLamela: null, 
      denumireCuloareLamela: '', 
      culoareCaseta: null, 
      denumireCuloareCaseta: '' 
    })
    debounce(this.calculPretCatalog, 500)()
    setTimeout(() => {
      validation(this.props.currentItem, this.props.errors, this.props.setErrors)
      this.handleAtentionareMaterial(e)
    }, 501);
  }
  //-------------------------------------------------------------------------------------------------------------------

  onChangeCuloareLamela = (e) => { 
    e.persist() 
    const { setCurrentItem, currentItem } = this.props;
    const opt = e.target.selectedOptions[0];

    let key = 'culoareLamela';
    let key2 = 'denumireCuloareLamela'
    let value = null;
    let value2 = '';
    if (currentItem) {
      value = opt?.dataset.key ? opt.dataset.key : 0
      value2 = opt?.dataset.denumire ? opt.dataset.denumire : ''
    }
    setCurrentItem({...currentItem, [key]: value, [key2]: value2})
    setTimeout(() => {
      validation(this.props.currentItem, this.props.errors, this.props.setErrors)
      this.handleAtentionareCuloareLamela(e)
    }, 501);
  }

  //-------------------------------------------------------------------------------------------------------------------

  handleAtentionareCuloareLamela = (e) => {
    const { currentItem, materiale, enqueueSnackbar } = this.props;
    if (currentItem) {
      if (e.target.value) {
        var cod1 = materiale.filter(mat => (mat.key === currentItem.material && mat.tipProdus.toUpperCase() === 'JV'))[0]?.coduris?.filter(cod => cod.denumire === currentItem.denumireCuloareLamela)[0]
        var mesaj = cod1 ? getLookupWarning(cod1) : ''
        var denumireCod1 = cod1 ? getLookupLabel(cod1) : currentItem.denumireCuloareLamela
      }
      if (mesaj) {
        enqueueSnackbar(denumireCod1 + ':' + mesaj, { 
          variant: 'warning',
        }, 15000)
      }
    }
  }
  
  //-------------------------------------------------------------------------------------------------------------------
  //-------------------------------------------------------------------------------------------------------------------

  onChangeCuloareCaseta = (e) => { 
    e.persist() 
    const { setCurrentItem, currentItem, materiale } = this.props;
    const opt = e.target.selectedOptions[0];
    let key = 'culoareCaseta';
    let key2 = 'denumireCuloareCaseta'
    let value = null;
    let value2 = '';
    if (currentItem) {
      value = opt?.dataset.key ? opt.dataset.key : 0
      value2 = opt?.dataset.denumire ? opt.dataset.denumire : ''
    }
    setCurrentItem({...currentItem, [key]: value, [key2]: value2})
    setTimeout(() => {
      validation(this.props.currentItem, this.props.errors, this.props.setErrors)
      this.handleAtentionareCuloareCaseta(e)
    }, 501);
  }

  //-------------------------------------------------------------------------------------------------------------------

  handleAtentionareCuloareCaseta = (e) => {
    const { currentItem, materiale, enqueueSnackbar } = this.props;
    if (currentItem) {
      if (e.target.value) {
        var cod2 = materiale.filter(mat => (mat.key === currentItem.material && mat.tipProdus.toUpperCase() === 'JV'))[0]?.coduris?.filter(cod => cod.denumire === currentItem.denumireCuloareCaseta)[0]
        var mesaj = cod2 ? getLookupWarning(cod2) : ''
        var denumireCod2 = cod2 ? getLookupLabel(cod2) : currentItem.denumireCuloareCaseta
      }
      if (mesaj) {
        enqueueSnackbar(denumireCod2 + ':' + mesaj, { 
          variant: 'warning',
        }, 15000)
      }
    }
  }
  //-------------------------------------------------------------------------------------------------------------------
    
  onChangeOptional1= (e)=>{ // tip console
    e.persist()
    const {setCurrentItem, currentItem}=this.props;
    let key = 'optional1';
    let key2='denumireOptional1'
    let value=null;
    let value2='';
    if (currentItem){
      value = e.target.value?this.optionale.filter(optional=>optional.denumire===e.target.value)[0].key:0
      value2=e.target.value?e.target.value:''
    }
    setCurrentItem({...currentItem, [key]: value, [key2]:value2})
    debounce(this.calculPretCatalog,500)()
    setTimeout(() => {
      validation(this.props.currentItem,this.props.errors,this.props.setErrors)
      this.handleAtentionareOptional1(e)
    }, 501);
    
  }
 //-------------------------------------------------------------------------------------------------------------------
 handleAtentionareOptional1=(e)=>{
  const {currentItem, enqueueSnackbar}=this.props;
  if (currentItem){
    if(e.target.value){
      var mesaj=this.optionale.filter(optional=>optional.denumire===currentItem.denumireOptional1)[0]?getLookupWarning(this.optionale.filter(optional=>optional.key===currentItem.optional1 && optional.activ==='DA')[0]):''
      var denumireOptional1=this.optionale.filter(optional=>optional.denumire===currentItem.denumireOptional1)[0]?getLookupLabel(this.optionale.filter(optional=>optional.key===currentItem.optional1 && optional.activ==='DA')[0]):''
    }
    if(mesaj){
      enqueueSnackbar(denumireOptional1+':'+mesaj,{ 
        variant: 'warning',
      },20000)
    }
  }
}

//-------------------------------------------------------------------------------------------------------------------
    
onChangeOptional2= (e)=>{ // optional
  e.persist()
  const {setCurrentItem, currentItem}=this.props;
  let key = 'optional2';
  let key2='denumireOptional2'
  let value=null;
  let value2='';
  if (currentItem){
    value = e.target.value?this.optionale.filter(optional=>optional.denumire===e.target.value)[0].key:0
    value2=e.target.value?e.target.value:''
  }
  setCurrentItem({...currentItem, [key]: value, [key2]:value2})
  debounce(this.calculPretCatalog,500)()
  setTimeout(() => {
    validation(this.props.currentItem,this.props.errors,this.props.setErrors)
    this.handleAtentionareOptional2(e)
  }, 501);
  
}
//-------------------------------------------------------------------------------------------------------------------
handleAtentionareOptional2=(e)=>{
const {currentItem, enqueueSnackbar}=this.props;
if (currentItem){
  if(e.target.value){
    var mesaj=this.optionale.filter(optional=>optional.denumire===currentItem.denumireOptional2)[0]?getLookupWarning(this.optionale.filter(optional=>optional.key===currentItem.optional2 && optional.activ==='DA')[0]):''
    var denumireOptional2=this.optionale.filter(optional=>optional.denumire===currentItem.denumireOptional2)[0]?getLookupLabel(this.optionale.filter(optional=>optional.key===currentItem.optional2 && optional.activ==='DA')[0]):''
  }
  if(mesaj){
    enqueueSnackbar(denumireOptional2+':'+mesaj,{ 
      variant: 'warning',
    },20000)
  }
}
}

  //-------------------------------------------------------------------------------------------------------------------
  onChangeDeschidere = (e) => {
    e.persist()
    const { setCurrentItem, currentItem } = this.props;
    let key = 'deschidere';
    let value = '';
    if (currentItem) {
      value = e.target.value
    }
    setCurrentItem({ ...currentItem, [key]: value })
    debounce(this.calculMp, 500)()
    debounce(this.calculPretCatalog, 500)()
    setTimeout(() => {
      this.handleAtentionareDeschidere(e)
    }, 501);
  }
  //-------------------------------------------------------------------------------------------------------------------
  onChange = (e) => {
    let key = e.target.name;
    let value = e.target.value;
    this.props.setCurrentItem({ ...this.props.currentItem, [key]: value.normalize('NFD').replace(/[var cod1 = materiale.filter(mat => (mat.key === currentItem.material && mat.tipProdus.toUpperCase() === 'JV'))[0]?.coduris?.filter(cod => cod.denumire === currentItem.denumireCuloareLamela)[0]undefinedvar mesaj = cod1 ? getLookupWarning(cod1) : ''undefinedvar denumireCod1 = cod1 ? getLookupLabel(cod1) : currentItem.denumireCuloareLamelau0300-var cod2 = materiale.filter(mat => (mat.key === currentItem.material && mat.tipProdus.toUpperCase() === 'JV'))[0]?.coduris?.filter(cod => cod.denumire === currentItem.denumireCuloareCaseta)[0]undefinedvar mesaj = cod2 ? getLookupWarning(cod2) : ''undefinedvar denumireCod2 = cod2 ? getLookupLabel(cod2) : currentItem.denumireCuloareCasetau036f]/g, '') })
    if (key === 'console') {
      debounce(this.handleAtentionareConsole, 500)()
      debounce(this.calculPretCatalog, 500)()
    }

    if (key === 'inaltime') {
      debounce(this.calculLungimeSnur, 500)()
      debounce(this.calculPretCatalog, 500)()
      debounce(this.calculMp, 500)()
    }
    if (key === 'lungime') {
      debounce(this.calculLungimeSnur, 500)()
      debounce(this.calculPretCatalog, 500)()
      debounce(this.calculMp, 500)()
    }
    if (key === 'culoareLamela') {
      debounce(this.calculPretCatalog, 500)()
    }
    if (key === 'culoareCaseta') {
      debounce(this.calculPretCatalog, 500)()
    }
    if (key === 'optional1') {
      debounce(this.calculPretCatalog, 500)()
    }
    if (key === 'optional2') {
      debounce(this.calculPretCatalog, 500)()
    }

    if (key === 'buc') {
      debounce(this.calculPretCatalog, 500)()
      debounce(this.calculMp, 500)()
    }

    setTimeout(() => {
      validation(this.props.currentItem, this.props.errors, this.props.setErrors)
    }, 50);
  }
  //-------------------------------------------------------------------------------------------------------------------
  calculLungimeSnur = async () => {
    const { setCurrentItem, currentItem } = this.props;
    setCurrentItem({ ...currentItem, lungimeSnur: actJV(currentItem.inaltime) })
  }
  //-------------------------------------------------------------------------------------------------------------------
  calculMp = async () => {
    const { setCurrentItem, currentItem } = this.props;
    setCurrentItem({ ...currentItem, mp: mpJV(currentItem.lungime, currentItem.inaltime, currentItem.deschidere) })
  }
  //-------------------------------------------------------------------------------------------------------------------
  calculPretCatalog = async () => {
    
    const { currentItem, setCurrentItem, materiale, currentUser, updatedOrder } = this.props
    
    const pretConsoleDefault = this.props.optionale.filter(optional => optional.key === 1)[0].pret
    const pretConsole = this.props.optionale.filter(optional => optional.key === currentItem.optional1 )[0]?.pret || 0
    const pretMaterialSelectat = materiale.filter(mat => (mat.key === currentItem.material && mat.tipProdus.toUpperCase() === 'JV'))[0] ? materiale.filter(mat => (mat.key === currentItem.material && mat.tipProdus.toUpperCase() === 'JV'))[0].pret : 0;
    const pretOptional2 = this.props.optionale.filter(optional => optional.key === currentItem.optional2)[0]?.pret || 0
    const pretCardanPrelungitor45=this.props.optionale.filter(optional => optional.key === 17)[0]?.pret || 0
    const tipMaterial = materiale.filter(material => material.key === currentItem.material && material.tipProdus.toUpperCase() === 'JV')[0] ? materiale.filter(material => material.key === currentItem.material && material.tipProdus.toUpperCase() === 'JV')[0].tipMaterial : '0'
    const numarCarucioare = carucioareJV(currentItem.lungime, currentItem.deschidere, tipMaterial, currentItem.tipSubprodus)
    const discount = currentUser.idFirma.discountJV
    const adaos = currentUser.idFirma.adaosJV
    const isComisionar = currentUser?.idFirma?.cfg1 === 'DA'
    const discountClientFinal = Number(updatedOrder?.discountClientFinal || 0)
    const pretCatalog = pretJV(mpJV(currentItem.lungime, currentItem.inaltime, currentItem.deschidere), pretMaterialSelectat, currentItem.console, pretConsole?pretConsole:pretConsoleDefault, numarCarucioare, currentItem.optional2, pretOptional2, currentItem.lungime, currentItem.deschidere, currentItem.buc, pretCardanPrelungitor45)
    const pretCuDiscount = (pretJV(mpJV(currentItem.lungime, currentItem.inaltime, currentItem.deschidere), pretMaterialSelectat, currentItem.console, pretConsole?pretConsole:pretConsoleDefault, numarCarucioare, currentItem.optional2, pretOptional2, currentItem.lungime,currentItem.deschidere, currentItem.buc, pretCardanPrelungitor45) * (1 - (discount ? discount / 100 : 0))).toFixed(2)
    const pretClientFinal = isComisionar
      ? (pretCatalog * (1 - (discountClientFinal ? discountClientFinal / 100 : 0))).toFixed(2)
      : (pretJV(mpJV(currentItem.lungime, currentItem.inaltime, currentItem.deschidere), pretMaterialSelectat, currentItem.console, pretConsole?pretConsole:pretConsoleDefault, numarCarucioare, currentItem.optional2, pretOptional2, currentItem.lungime,currentItem.deschidere, currentItem.buc, pretCardanPrelungitor45) * (1 + (adaos ? adaos / 100 : 0))).toFixed(2)
    setCurrentItem({ ...currentItem, pretCatalog: pretCatalog, pretCuDiscount: pretCuDiscount, pretClientFinal: pretClientFinal })
    console.log("DESCHIDERE:",currentItem.deschidere)
  }

  //-------------------------------------------------------------------------------------------------------------------  
  closeModal = () => {
    const { setOpenEditItem } = this.props;
    setOpenEditItem({ open: false, title: '', add: true });
  }
  //-------------------------------------------------------------------------------------------------------------------
  handlerSumbit = async (e) => {
    e.preventDefault()
    const { openEditItem, adaugaItem, modificaItem, enqueueSnackbar } = this.props;
    const validare = await validation(this.props.currentItem, this.props.errors, this.props.setErrors)

    if (validare === false) {
        enqueueSnackbar(t('orderLineEdit.validationError'), {
        variant: 'error',
      })
      return
    }

    if (openEditItem.add === true) {
      return adaugaItem()
    } else {
      return modificaItem()
    }
  }
  //-------------------------------------------------------------------------------------------------------------------
  handlerKeyDown = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      return false;
    }
  }
   //-------------------------------------------------------------------------------------------------------------------
   handleAtentionareTipSubprodus=(e)=>{
    const {currentItem, enqueueSnackbar}=this.props;
    if (currentItem){
      if(e.target.value){
        var mesaj=this.produse.filter(produs=>produs.denumire===currentItem.denumireSubProdus)[0]?getLookupWarning(this.produse.filter(produs=>produs.denumire===currentItem.denumireSubProdus)[0]):''
        var denumireTipSubprodus=this.produse.filter(produs=>produs.denumire===currentItem.denumireSubProdus)[0]?getLookupLabel(this.produse.filter(produs=>produs.denumire===currentItem.denumireSubProdus)[0]):''
      }
      if(mesaj){
        enqueueSnackbar(denumireTipSubprodus+':'+mesaj,{ 
          variant: 'warning',
        },20000)
      }
    }
  }
  //-------------------------------------------------------------------------------------------------------------------
  handleAtentionareMaterial = (e) => {
    const { currentItem, materiale, enqueueSnackbar } = this.props;
    if (currentItem) {
      if (e.target.value) {
        var mesaj = getLookupWarning(materiale.filter(mat => mat.denumire === e.target.value && mat.tipProdus.toUpperCase() === 'JV')[0])
        var denumireMaterial = getLookupLabel(materiale.filter(mat => mat.denumire === e.target.value && mat.tipProdus.toUpperCase() === 'JV')[0])
      }
      if (mesaj) {
        enqueueSnackbar(denumireMaterial + ':' + mesaj, {
          variant: 'warning',
        }, 15000)
      }
    }

  }
  //-------------------------------------------------------------------------------------------------------------------
  handleAtentionareDeschidere = (e) => {
    const { currentItem, enqueueSnackbar } = this.props;
    if (currentItem) {
      if (e.target.value) {
        var mesaj = this.deschideri.filter(des => des.denumire === e.target.value)[0].atentionare
        var denumireDeschidere = this.deschideri.filter(des => des.denumire === e.target.value)[0].denumire
      }
      if (mesaj) {
        enqueueSnackbar(t('orderLineForm.openingWarningPrefix', { value: denumireDeschidere, message: mesaj }), {
          variant: 'warning',
        }, 20000)
      }
    }
  }
  //-------------------------------------------------------------------------------------------------------------------
  handleAtentionareConsole = (e) => {
    const { enqueueSnackbar } = this.props
    if(!this.props.currentItem.optional1){
      enqueueSnackbar(t('orderLineForm.consoleDefaultWarning'), {
        variant: 'warning',
      }, 20000)
    }
  }
  //-------------------------------------------------------------------------------------------------------------------
  handleCarucioare = () => {
    const { currentItem, materiale } = this.props
    let tipMaterial = materiale.filter(material => material.key === currentItem.material && material.tipProdus.toUpperCase() === 'JV')[0] ? materiale.filter(material => material.key === currentItem.material && material.tipProdus.toUpperCase() === 'JV')[0].tipMaterial : '0'
    return carucioareJV(currentItem.lungime, currentItem.deschidere, tipMaterial, currentItem.tipSubprodus)
  }

  //----------------------------------------------------------------------------------------------------
  vanzatorVizibilitate = () => {
    const { currentUser } = this.props;
    if (currentUser.role.name === 'Vanzator') {
      return false;
    } else {
      return true;
    }
  }

  render() {
    const { currentItem, openEditItem, materiale, errors } = this.props
    const selectedTipSubprodus = this.produse.find(produs => produs.key === currentItem.tipSubprodus) || null;
    const selectedDenumireSubProdus = currentItem.denumireSubProdus
      || selectedTipSubprodus?.denumire
      || '';
    const selectedMaterial = selectedTipSubprodus?.materialeCompatibile
      ?.find(material => material.key === currentItem.material) || null;
    const selectedDenumireMaterial = currentItem.denumireMaterial
      || selectedMaterial?.denumire
      || '';
    return (
      <Popup
        closeOnDocumentClick={false}
        /* onclose={}*/
        open={openEditItem.open}
      >
        <Card>
          <form
            autoComplete="off"
            onSubmit={this.handlerSumbit}
          >
            <CardHeader
              title={openEditItem.title.toUpperCase()}
            />
            <Divider />
            <CardContent style={{ overflow: 'scroll', maxHeight: '350px' }} >
              <Grid
                container
                spacing={1}
              >
                <Grid
                      item
                      lg={2}
                      xs={12}
                    >
                      <TextField
                        autoFocus
                        fullWidth
                        InputLabelProps={{shrink:true}}
                        label={t('orderLineForm.typeVenetian')}
                        margin="dense"
                        name="tipSubprodus"
                        onChange={this.onChangeTipSubprodus}
                        required
                        select
                        SelectProps={{
                          native: true,
                          MenuProps: {
                          }
                        }}
                        value={selectedDenumireSubProdus}
                        variant="outlined"
                      >
                        <option
                          key={''}
                          value={''}
                        >
                          {''}
                        </option>
                        {this.produse.filter(produs=>produs.activ.toUpperCase()!=='NU').sort(dynamicMultipleSort('pozitieLista','denumire')).map(option => (
                          <option
                            key={option.key}
                            value={option.denumire}
                          >
                            {getLookupLabel(option)}
                          </option>
                        ))}
                      </TextField>
                    </Grid>
                <Grid
                  item
                  lg={1}
                  xs={12}
                >
                  <TextField
                    autoFocus
                    error={errors.m1m.mesaj || errors.m2m.mesaj ? true : false}
                    fullWidth
                    helperText={errors.m1m.mesaj ? errors.m1m.mesaj : '' + errors.m2m.mesaj ? errors.m2m.mesaj : ''}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ style: { textAlign: 'right' } }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">{t('orderLineForm.unitMm')}</InputAdornment>,
                    }}
                    label={t('orderLineForm.widthRail')}
                    margin="dense"
                    name="lungime"
                    onChange={this.onChange}
                    onKeyDown={this.handlerKeyDown}
                    required
                    value={currentItem.lungime || ''}
                    variant="outlined"

                  />
                </Grid>
                <Grid
                  item
                  lg={1}
                  xs={12}
                >
                  <TextField
                    error={errors.m3m.mesaj || errors.m4m.mesaj ? true : false}
                    fullWidth
                    helperText={errors.m3m.mesaj ? errors.m3m.mesaj : '' + errors.m4m.mesaj ? errors.m4m.mesaj : ''}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ style: { textAlign: 'right' } }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">{t('orderLineForm.unitMm')}</InputAdornment>,
                    }}
                    label={t('orderLineForm.height')}
                    margin="dense"
                    name="inaltime"
                    onChange={this.onChange}
                    onKeyDown={this.handlerKeyDown}
                    required={currentItem.denumireMaterial !== 'GARNISA' ? true : false}
                    value={currentItem.inaltime || ''}
                    variant="outlined"
                  />
                </Grid>

                <Grid
                  item
                  lg={1}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                        startAdornment: <InputAdornment position="start">{t('orderLineForm.tPrefix')}</InputAdornment>,
                    }}
                    label={t('orderLineForm.openingType')}
                    margin="dense"
                    name="deschidere"
                    onChange={this.onChangeDeschidere}
                    required
                    select
                    SelectProps={{
                      native: true,
                      MenuProps: {
                      }
                    }}
                    value={currentItem.deschidere || ''}
                    variant="outlined"
                  >
                    <option
                      key={''}
                      value={''}
                    >
                      {''}
                    </option>
                    {this.deschideri.map(option => (
                      <option
                        key={option.key}
                        value={option.denumire}
                      >
                        {getLookupLabel(option)}
                      </option>
                    ))}
                  </TextField>
                </Grid>

                <Grid
                  item
                  lg={2}
                  xs={12}
                >
                  <TextField
                        fullWidth
                        InputLabelProps={{shrink:true}} 
                        label={t('orderLineForm.material')}
                        margin="dense"
                        name="material"
                        onChange={this.onChangeMaterial}
                        required
                        select
                        SelectProps={{
                          native: true,
                          MenuProps: {
                          }
                        }}
                        value={selectedDenumireMaterial}
                        variant="outlined"
                      >
                        <option
                          key={''}
                          value={''}
                        >
                          {''}
                        </option>
                        {this.produse.filter(produs=>produs.activ.toUpperCase()!=='NU' && produs.key===currentItem.tipSubprodus)[0]?
                          this.produse.filter(produs=>produs.activ.toUpperCase()!=='NU' && produs.key===currentItem.tipSubprodus)[0].materialeCompatibile[0]?
                            this.produse.filter(produs=>produs.activ.toUpperCase()!=='NU' && produs.key===currentItem.tipSubprodus)[0].materialeCompatibile.filter(material=>material.activ.toUpperCase()!=='NU')[0]?
                              this.produse.filter(produs=>produs.activ.toUpperCase()!=='NU' && produs.key===currentItem.tipSubprodus)[0].materialeCompatibile.filter(material=>material.activ.toUpperCase()!=='NU').sort(dynamicMultipleSort('pozitieLista','denumire')).map(option => (
                                <option
                                  key={option.key}
                                  value={option.denumire}
                                >
                                  {getLookupLabel(option)}
                                </option>
                              )):0:0:0}
                      </TextField>
                </Grid>



                <Grid
                  item
                  lg={1}
                  xs={12}
                >
                  <TextField
                    key={`culoareLamela-${currentItem.material || 'empty'}`}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    label={t('orderLineForm.code1')}
                    margin="dense"
                    name="culoareLamela" 
                    onChange={this.onChangeCuloareLamela}
                    select
                    SelectProps={{
                      native: true,
                      MenuProps: {
                      }
                    }}
                    value={currentItem.denumireCuloareLamela || ''}
                    variant="outlined"
                  >
                    <option
                      key={''}
                      value={''}
                    >
                      {''}
                    </option>
                    {currentItem.material && materiale.filter(mat => mat.key === currentItem.material && mat.tipProdus.toUpperCase() === 'JV').length > 0 ?
                      materiale.filter(mat => mat.key === currentItem.material && mat.tipProdus.toUpperCase() === 'JV')[0]?.coduris
                        ?.filter(cod => cod.activ.toUpperCase() !== 'NU')
                        ?.sort(dynamicSort('denumire'))
                        .map(option => (
                          <option
                            key={option.key}
                            value={option.denumire}
                            data-key={option.key}
                            data-denumire={option.denumire}
                          >
                             {option.subTip?option.subTip:getLookupLabel(option)}
                          </option>
                        )) : null}
                  </TextField>
                </Grid>
                <Grid
                  item
                  lg={1}
                  xs={12}
                >
                  <TextField
                    key={`culoareCaseta-${currentItem.material || 'empty'}`}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    label={t('orderLineForm.code2')}
                    margin="dense"
                    name="culoareCaseta" 
                    onChange={this.onChangeCuloareCaseta}
                    select
                    SelectProps={{
                      native: true,
                      MenuProps: {
                      }
                    }}
                    value={currentItem.denumireCuloareCaseta || ''}
                    variant="outlined"
                    hidden={true}
                  >
                    <option
                      key={''}
                      value={''}
                    >
                      {''}
                    </option>
                    {currentItem.material && materiale.filter(mat => mat.key === currentItem.material && mat.tipProdus.toUpperCase() === 'JV').length > 0 ?
                      materiale.filter(mat => mat.key === currentItem.material && mat.tipProdus.toUpperCase() === 'JV')[0]?.coduris
                        ?.filter(cod => cod.activ.toUpperCase() !== 'NU')
                        ?.sort(dynamicSort('denumire'))
                        .map(option => (
                          <option
                            key={option.key}
                            data-key={option.key}
                            data-denumire={option.denumire}
                            value={option.denumire}
                          >
                             {option.subTip?option.subTip:getLookupLabel(option)}
                          </option>
                        )) : null}
                  </TextField>
                </Grid>





                <Grid
                  item
                  lg={3}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    label={t('orderLineForm.codeCombination')}
                    margin="dense"
                    name="codMaterial"
                    onChange={this.onChange}
                    onKeyDown={this.handlerKeyDown}
                    value={currentItem.codMaterial || ''}
                    variant="outlined"
                    hidden={true}
                  />
                </Grid>
                <Grid
                  item
                  lg={1}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ style: { textAlign: 'right' } }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">{t('orderLineForm.unitMm')}</InputAdornment>,
                    }}
                    label={t('orderLineForm.cordLength')}
                    margin="dense"
                    name="lungimeSnur"
                    onChange={this.onChange}
                    onKeyDown={this.handlerKeyDown}
                    value={currentItem.lungimeSnur || ''}
                    variant="outlined"
                  />
                </Grid>

                <Grid
                  item
                  lg={3}
                  xs={12}
                >
                  <TextField
                    key={`tipConsole-${currentItem.optional1 || 'empty'}`}
                    error={errors.m5m.mesaj || errors.m5m.mesaj ? true : false}
                    fullWidth
                    helperText={errors.m5m.mesaj ? errors.m5m.mesaj : '' }
                    InputLabelProps={{ shrink: true }}
                    label={t('orderLineForm.consoleType')}
                    margin="dense"
                    name="optional1" 
                    onChange={this.onChangeOptional1}
                    select
                    SelectProps={{
                      native: true,
                      MenuProps: {
                      }
                    }}
                    value={currentItem.denumireOptional1 || ''}
                    variant="outlined"
                  >
                    <option
                      key={''}
                      value={''}
                    >
                      {''}
                    </option>
                    { this.optionale && this.optionale.filter(opt => opt.tipProdus.toUpperCase() === 'JV' && opt.denumire.substring(0,4).toUpperCase() === 'CONS' && opt.activ.toUpperCase() !== 'NU' && opt.key !== 2).length > 0 ?
                      this.optionale.filter(opt => opt.tipProdus.toUpperCase() === 'JV' && opt.denumire.substring(0,4).toUpperCase() === 'CONS' && opt.activ.toUpperCase() !== 'NU' && opt.key !== 2)
                        ?.sort(dynamicSort('denumire'))
                        .map(option => (
                          <option
                            key={option.key}
                            value={option.denumire}
                          >
                            {getLookupLabel(option)}
                          </option>
                        )) : null}
                  </TextField>
                </Grid>



                <Grid
                  item
                  lg={1}
                  md={12}
                >
                  <TextField
                    error={errors.m6m.mesaj || errors.m6m.mesaj ? true : false}
                    fullWidth
                    helperText={errors.m6m.mesaj ? errors.m6m.mesaj : '' }
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{ style: { textAlign: 'right' } }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">{t('orderLineForm.unitCons')}</InputAdornment>,
                    }}
                    label={t('orderLineForm.consoleCount')}
                    margin="dense"
                    name="console"
                    onChange={this.onChange}
                    onKeyDown={this.handlerKeyDown}
                    value={currentItem.console || ''}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  lg={2}
                  xs={12}
                >
                  <TextField
                    key={`optional-${currentItem.optional2 || 'empty'}`}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    label={t('orderLineForm.optional')}
                    margin="dense"
                    name="optional2" 
                    onChange={this.onChangeOptional2}
                    select
                    SelectProps={{
                      native: true,
                      MenuProps: {
                      }
                    }}
                    value={currentItem.denumireOptional2 || ''}
                    variant="outlined"
                  >
                    <option
                      key={''}
                      value={''}
                    >
                      {''}
                    </option>
                    { this.optionale && this.optionale.filter(opt => opt.tipProdus.toUpperCase() === 'JV' && opt.denumire.substring(0,4).toUpperCase() !== 'CONS' && opt.activ.toUpperCase() !== 'NU' && opt.key !== 2).length > 0 ?
                      this.optionale.filter(opt => opt.tipProdus.toUpperCase() === 'JV' && opt.denumire.substring(0,4).toUpperCase() !== 'CONS' && opt.activ.toUpperCase() !== 'NU' && opt.key !== 2)
                        ?.sort(dynamicSort('denumire'))
                        .map(option => (
                          <option
                            key={option.key}
                            value={option.denumire}
                          >
                            {getLookupLabel(option)}
                          </option>
                        )) : null}
                  </TextField>
                </Grid>
                <Grid
                      item
                      lg={3}
                      xs={12}
                    >
                      <TextField
                        fullWidth
                        InputLabelProps={{
                          shrink:true
                        }}
                        label={t('orderLineForm.notes')}
                        margin="dense"
                        name="observatii"
                        onChange={this.onChange}
                        onKeyDown={this.handlerKeyDown}
                        value={currentItem.observatii || ''}
                        variant="outlined"
                      />
                    </Grid>

                <Grid
                  item
                  lg={1}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{ style: { textAlign: 'right' } }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">{t('orderLineForm.unitPieces')}</InputAdornment>,
                    }}
                    label={t('orderLineForm.quantity')}
                    margin="dense"
                    name="buc"
                    onBlur={this.calculPretCatalog}
                    onChange={this.onChange}
                    onKeyDown={this.handlerKeyDown}
                    required
                    value={currentItem.buc || ''}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  lg={12}
                  md={12}
                  xs={12}
                >
                  <Divider style={{ background: colors.blueGrey[700] }} />
                </Grid>
                <Grid
                  container
                  justify="flex-end"
                  spacing={1}
                  style={{ background: colors.blueGrey[100] }}
                >
                  <Grid
                    item
                    lg={1}
                    xs={12}
                  >
                    <TextField

                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ style: { textAlign: 'right' } }}
                      InputProps={{
                        endAdornment: <InputAdornment position="end">{t('orderLineForm.unitPieces')}</InputAdornment>,
                        readOnly: true,
                      }}
                      label={t('orderLineForm.cartsPerPiece')}
                      margin="dense"
                      name="carucioare"
                      value={this.handleCarucioare()}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    lg={1}
                    xs={12}
                  >
                    <TextField

                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ style: { textAlign: 'right' } }}
                      InputProps={{
                        endAdornment: <InputAdornment position="end">{t('orderLineForm.unitMp')}</InputAdornment>,
                        readOnly: true,
                      }}
                      label={t('orderLineForm.mpPerPiece')}
                      margin="dense"
                      name="mp"
                      onChange={this.onChange}
                      onKeyDown={this.handlerKeyDown}
                      required
                      value={currentItem.mp || ''}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    lg={1}
                    xs={12}
                  >
                    <TextField

                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ style: { textAlign: 'right' } }}
                      InputProps={{
                        endAdornment: <InputAdornment position="end">{t('orderLineForm.unitMp')}</InputAdornment>,
                        readOnly: true,
                      }}
                      label={t('orderLineForm.totalMp')}
                      margin="dense"
                      name="mp"
                      onChange={this.onChange}
                      onKeyDown={this.handlerKeyDown}
                      required
                      value={currentItem.mp && currentItem.buc ? currentItem.mp * currentItem.buc : 0}
                      variant="outlined"
                    />
                  </Grid>
                  <Hidden
                    xlDown={!this.vanzatorVizibilitate()}
                    xlUp={!this.vanzatorVizibilitate()}
                  >
                    <Grid
                      item
                      lg={2}
                      xs={12}
                    >
                      <TextField
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ style: { textAlign: 'right' } }}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">{t('orderLineForm.unitLei')}</InputAdornment>,
                          readOnly: true,
                        }}
                        label={t('orderLineForm.catalogPrice')}
                        margin="dense"
                        name="pretCatalog"
                        onChange={this.onChange}
                        onKeyDown={this.handlerKeyDown}
                        required
                        value={currentItem.pretCatalog || 0}
                        variant="outlined"
                      />

                    </Grid>
                    <Grid
                      item
                      lg={2}
                      xs={12}
                    >
                      <TextField
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ style: { textAlign: 'right' } }}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">{t('orderLineForm.unitLei')}</InputAdornment>,
                          readOnly: true,
                        }}
                        label={t('orderLineForm.orderPrice')}
                        margin="dense"
                        name="pretCuDiscount"
                        onChange={this.onChange}
                        onKeyDown={this.handlerKeyDown}
                        required
                        value={currentItem.pretCuDiscount || 0}
                        variant="outlined"
                      />
                    </Grid>
                  </Hidden>
                  <Grid
                    item
                    lg={2}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ style: { textAlign: 'right' } }}
                      InputProps={{
                          endAdornment: <InputAdornment position="end">{t('orderLineForm.unitLei')}</InputAdornment>,
                      }}
                      label={t('orderLineForm.clientPrice')}
                      margin="dense"
                      name="pretClientFinal"
                      onChange={this.onChange}
                      onKeyDown={this.handlerKeyDown}
                      required
                      value={currentItem.pretClientFinal || 0}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </Grid>

            </CardContent>
            <Divider />
            <p>{t('orderLineEdit.clientPriceEditableNote')}</p>
            <p style={{ color: 'maroon' }}>{t('orderLineForm.jvHeightNote')}</p>
            <CardActions style={{ display: 'flex', justifyContent: 'flex-end' }} >
              <Button
                color="primary"
                style={{ background: colors.blueGrey[500], color: 'white' }}
                type="submit"
                variant="contained"
              >
                {t('orderLineEdit.save')}
              </Button>
              <Button
                color="primary"
                onClick={this.closeModal}
                style={{ background: colors.red[900], color: 'white' }}
                variant="contained"
              >
                {t('orderLineEdit.cancel')}
              </Button>
            </CardActions>
          </form>
        </Card>
      </Popup>
    );
  }

}

const mapStateToProps = state => ({
  currentProduct: selectOrderCurrentProduct(state),
  currentUser: selectCurrentUser(state),
  currentOrder: selectOrderCurrentOrder(state),
  updatedOrder: selectOrderUpdatedOrder(state),
  currentItem: selectOrderCurrentItem(state),
  loading: selectOtherLoading(state),
  produse:selectLookupProduse(state),
  materiale: selectLookupMateriale(state),
  optionale: selectLookupOptionale(state),
  openEditItem: selectOtherOpenEditItem(state),
  errors: selectOtherErrors(state)
})

const mapDispatchToProps = dispatch => ({
  setLoading: boll => dispatch(setLoading(boll)),
  setCurrentItem: item => dispatch(setCurrentItem(item)),
  setOpenEditItem: bool => dispatch(setOpenEditItem(bool)),
  setErrors: error => dispatch(setErrors(error)),
  resetErrors: () => dispatch(resetErrors()),
  setErrorsAsync: () => dispatch(setErrorsAsync()),
})
export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(ReperEdit));